const MOMS = new Map();

export default MOMS
